import {PLAN_NAME_PARTY_PASS, PLAN_NAME_PRO} from '~/common/fabric/routes/EventReview/constants';

export const isProOrPartyPassUser = (subscriptionPlanName: string | undefined) =>
  Boolean(
    subscriptionPlanName && [PLAN_NAME_PRO, PLAN_NAME_PARTY_PASS].includes(subscriptionPlanName)
  );

const STEP_4_UX_REFRESH_DESKTOP_EXP_NAME = 'test_step-4-refresh-desktop';
const STEP_4_UX_REFRESH_MW_EXP_NAME = 'test_step-4-refresh-mw';
export const isInStep4RefreshVariation = (isDesktop: boolean, readonly = true) => {
  const expName = isDesktop ? STEP_4_UX_REFRESH_DESKTOP_EXP_NAME : STEP_4_UX_REFRESH_MW_EXP_NAME;
  return evite.experiments.inVariation(expName, 'variant', false, readonly);
};
